import { render, staticRenderFns } from "./UnitsAtConsignee.vue?vue&type=template&id=20428ec3&"
import script from "./UnitsAtConsignee.vue?vue&type=script&lang=js&"
export * from "./UnitsAtConsignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports